import React, { memo } from 'react';

type FormatStringType = {
  oldString: string;
  search?: string;
};

export const HighlightedString = memo(({ oldString, search }: FormatStringType) => {
  if (!search?.trim()) {
    return <span>{oldString}</span>;
  }

  const parts = oldString.split(new RegExp(`(${search.trim()})`, 'gi'));

  return (
    <span>
      {parts.map((part, i) => (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          style={
            part.toLowerCase() === search.trim().toLowerCase() && i < 3
              ? { color: '#7EB3BD' }
              : {}
          }
        >
          {part}
        </span>
      ))}
    </span>
  );
});
